/**
 * wireAltarUnlock — Debug button + window hook to unlock TT altars (P3-04b / TT-07).
 * Match clock lives on MatchRuntime (P3-01); presentation only wires UI.
 */
export function wireAltarUnlock({
  matchRuntime,
  buttonId = 'unlock-altars-btn'
} = {}) {
  function unlock() {
    if (!matchRuntime || typeof matchRuntime.unlockAltars !== 'function') {
      return null;
    }
    return matchRuntime.unlockAltars();
  }

  const btn = typeof document !== 'undefined'
    ? document.getElementById(buttonId)
    : null;
  if (btn) {
    btn.addEventListener('click', () => unlock());
  }

  if (typeof window !== 'undefined') {
    window.__debugUnlockAltars = unlock;
  }

  return { unlock };
}
